(() => {
  if (window.sdFeaturedQuantityControlsReady) return;
  window.sdFeaturedQuantityControlsReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sd-quantity-change]');
    if (!button || !button.closest('.sd-featured')) return;

    const quantity = button.closest('[data-sd-quantity]');
    const input = quantity?.querySelector('input[name="quantity"]');
    if (!input) return;

    const change = Number(button.dataset.sdQuantityChange);
    const minimum = Number(input.min || 1);
    const current = Number(input.value || minimum);
    input.value = Math.max(minimum, current + change);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
